import { IExportColumnModel } from "../../../../shared/models";

export const AccountDomainColumnList: IExportColumnModel[] = [
]